export function createHeader(level, text) {
  let header = document.createElement(level);
  let headerText = document.createTextNode(text);
  header.appendChild(headerText);
  return header;
}

export function createLink (href, text, customClass) {
  let link = document.createElement('a');
  let linkText = document.createTextNode(text);
  link.href = href;
  link.classList.add(customClass);
  link.appendChild(linkText);
  return link;
}

export function createParagraph (text, customClass) {
  let paragraph = document.createElement('p');
  let paragraphText = document.createTextNode(text);
  paragraph.classList.add(customClass);
  paragraph.appendChild(paragraphText);
  return paragraph;
}

export function createInput (parent, labelText, name, type, value = '', required = false, placeholder = '', min, max, maxlength, size, pattern) {
  //label
  if(type!='submit' && type!='hidden'){
    let label = document.createElement('label');
    let labelElText = document.createTextNode(labelText);
    label.appendChild(labelElText);
    parent.appendChild(label);
  }
  //input
  let input = document.createElement('input');
  input.type = type;
  input.value = value;
  input.name = name;
  input.placeholder = placeholder;
  if( required ){
    input.required = true;
  }
  if( min ){
    input.min = min;
  }
  if( max ){
    input.max = max;
  }
  if( length ){
    input.length = length;
  }
  if( size ){
    input.size = size;
  }
  if( pattern ){
    input.pattern = pattern;
  }
  parent.appendChild(input);
  return input;
}

export function createDobInput(){
  let dobContainer = document.createElement('div');
  dobContainer.classList.add('dob-input-cont');
  //label
  let dobLabel = document.createElement('label');
  let labelText = document.createTextNode('Date of Birth');
  dobLabel.appendChild( labelText );
  //day
  let dayCont = document.createElement('div');
  let dayInput = createInput( dayCont, 'Day', 'dob-day', 'number', '', true, 'dd', 1, 31, 2, 2, '[0-9]{2}' );
  dayInput.classList.add('dob-input');
  //month
  let monthCont = document.createElement('div');
  let monthInput = createInput( monthCont, 'Month', 'dob-month', 'number', '', true, 'mm', 1, 12, 2, 2, '[0-9]{2}' );
  monthInput.classList.add('dob-input');
  //year
  let yearCont = document.createElement('div');
  let yearInput = createInput( yearCont, 'Year', 'dob-year', 'number', '', true, 'yyyy', 1900, 2015, 4, 4, '[0-9]{4}' );
  yearInput.classList.add('dob-input');

  dobContainer.appendChild(dobLabel);
  dobContainer.appendChild(dayCont);
  dobContainer.appendChild(monthCont);
  dobContainer.appendChild(yearCont);

  return dobContainer;

}

export function createCloseButton (parent, text, name, type, customClass) {
  let button = document.createElement('button');
  button.type = type;
  let buttonText = document.createTextNode(text);
  button.appendChild(buttonText);
  button.addEventListener('click', function () {
    parent.parentNode.removeChild(parent);
  })
  //custom class
  if( customClass ){
    button.classList.add( customClass );
  }
  return button;
}

export function createInfoBlock( label, blocks = [], classes = [] ){
  let containerEl = document.createElement('div');
  //label
  if( label ){
    let labelEl = document.createElement('label');
    let labelElText = document.createTextNode( label );
    labelEl.appendChild( labelElText );
    containerEl.appendChild( labelEl );
  }
  //info
  blocks.forEach( ( block ) => {
    let blockEl = null;
    if( block.type === 'node'){
      blockEl = block.content;
    } else {
      blockEl = document.createElement('p');
      if( block.innerhtml ){
        blockEl.innerHTML = block.content;
      } else {
        let blockElContents = document.createTextNode( block.content );
        blockEl.appendChild( blockElContents );
      }
    }
    containerEl.appendChild( blockEl );
  })

  return containerEl;
}

export function createBackButton( text, customClass ){
  let backButtonEl = document.createElement('button');
  let backButtonText = document.createTextNode( text );
  if( customClass ){
    backButtonEl.classList.add( customClass );
  }
  backButtonEl.addEventListener( 'click', window.history.back() );

  return backButtonEl;

}

export function createConfirmationCheckbox( name, id, labelText, required, customClass ){
  let checkboxCont = document.createElement('div');
  if( customClass ){
    checkboxCont.classList.add( customClass );
  }
  let checkboxEl = document.createElement('input');
  checkboxEl.type = 'checkbox';
  checkboxEl.required = required;
  checkboxEl.name = name;
  checkboxEl.id = id;
  let labelEl = document.createElement('label');
  labelEl.setAttribute('for', id);
  let labelElText = document.createTextNode( labelText );
  labelEl.appendChild( labelElText );
  checkboxCont.appendChild( checkboxEl );
  checkboxCont.appendChild( labelEl );
  return checkboxCont;
}